export const getInternalToolGenericDataVariables = ({ orgId, addOnType }) => {
  return {
    input: {
      apiType: "ADD_ON_MANAGER",
      params: {
        organizationId: orgId,
        addOnType: addOnType,
      },
    },
  };
};
